import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  DefaultLanguage, getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import Button from '@material-ui/core/Button';
import {
  translate,
} from '../../helperFunctions/translation';
import classes from './addEditGate.module.scss';
import { ICountry } from '../../mobx-store/storeInterfaces/authInterface';
import { countriesIsoCodes } from '../../constants/countries';
import { CountryStore } from '../../mobx-store/stores/countryStore';
import {
  IBranchStore,
} from '../../mobx-store/storeInterfaces/branchInterface';
import { IGateStore, GateOpenTimeInterval } from '../../mobx-store/storeInterfaces/gateStoreInterface';
import CustomerServiceWorkingDay from '../../components/CustomerServiceWorkingDayComponent';
import { CustomerServiceDay, TimeEdge, WeekDays } from '../../mobx-store/storeInterfaces/customerServiceStoreInterface';

interface IProps extends WithSnackbarProps {
  countryStore: CountryStore;
  history: any;
  branchStore: IBranchStore;
  gateStore: IGateStore;
  match: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  selectedLang: string;
  disabled: boolean;
  processing: boolean;
  intervals: CustomerServiceDay[];
}

@inject('branchStore')
@inject('gateStore')
@inject('countryStore')
class AddEditGate extends Component<IProps, IState> {
  isNew = false;

  isEgypt = false;

  gateId = '';

  pageTitle = '';

  gateFormTitle = '';

  gateSchema: any;

  lastHistory = -1;

  submitButton: any;

  cancelButton: any;

  form: any;

  dropdownLanguages: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null;

  constructor(props: IProps) {
    super(props);
    
    if (this.props.match.params.id) {
      this.isNew = false;
      this.gateId = this.props.match.params.id;
      this.pageTitle = translate('editGatePageTitle', {});
    } else {
      this.isNew = true;
      this.pageTitle = translate('addGatePageTitle', {});
    }
    this.initBranchSchema();
    this.initState();
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.dropdownLanguages = this.getDropdownLanguages();
    this.gateFormTitle = translate('addGatePageFormTitle', {});
  }

  updateStateWithBranchesData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      if (field.name === 'branchId') {
        formFieldsWithData.push(
          {
            ...field, selectList: this.props.branchStore.branchesList,
          },
        );
      } else {
        formFieldsWithData.push(field);
      }
    }
    this.setState({
      formFields: formFieldsWithData,
    });
  };


  initBranchSchema = () => {
    this.gateSchema = Yup.object().shape({
      title: Yup.string().required('Required'),
      branchId: Yup.number().required('Required'),
      isActive: Yup.boolean().default(true),
    });
  };

  getFormFields = (): FormField[] => [
    {
      name: 'title',
      label: this.isNew && this.isEgypt ? 'Arabic Title' : 'Gate Title',
      type: 'text',
      filedType: 'InputField',
      disabled: false,
    },
    {
      name: 'branchId',
      label: translate('GatePageFormAvailableBranches', {}),
      selectList: [],
      selectListValue: 'title',
      selectListKey: 'id',
      filedType: 'DropdownField',
    },
    {
      name: 'isActive',
      label: translate('addAcademyPageFormStatus', {
      }),
      filedType: 'ToggleButtonField',
      activeLabel: translate('addAcademyPageFormStatusActiveLabel', {
      }),
      inactiveLabel: translate('addAcademyPageFormStatusInactiveLabel', {
      })
    },
  ];

  generateEmptyTimeIntervals = () => {
    let intervals: any[] = [];
    for(let day in WeekDays) {
      intervals.push({
        day: day.replace(day.substring(1), day.substring(1).toLowerCase()),
        isOpen: false,
        startTime: null,
        endTime: null
      });
    } 
    
    return intervals;
  }

  initState = () => {

    this.state = {
      processing: false,
      selectedLang: languageCodes.english,
      loading: !this.isNew,
      disabled: false,
      formFields: this.getFormFields(),
      intervals: this.generateEmptyTimeIntervals(),
    };
  };

  toggleDayAvailability = (index: number) => {

    const intervals = this.state.intervals;
    intervals[index].isOpen = !intervals[index].isOpen;
    if(!intervals[index].isOpen) {
      intervals[index].startTime = null;
      intervals[index].endTime = null;
    }
    this.setState({intervals}, () => {
      this.canSubmit();
    })
  }

  canSubmit = () => {
    for(var i=0; i<this.state.intervals.length; i++) {
      const slot: CustomerServiceDay = this.state.intervals[i];
      if(!slot.isOpen || (slot.isOpen && !!slot.startTime && !!slot.endTime)) {
        this.setState({disabled: false})
      } else {
        this.setState({disabled: true});
        break;
      }
    }
  }

  onChangeTime = (index: number, edge: TimeEdge, val: string) => {
    const intervals = this.state.intervals;
    intervals[index][edge] = !!val? val+':00' : undefined;
    this.setState({intervals}, () => {
      this.canSubmit();
    });  
  }

  renderWeekDays = () => {
    
    return this.state.intervals.map((slot: any, i) => {
      
      const isValid: boolean = (slot.isOpen && !!slot.startTime && !!slot.endTime) || !slot.isOpen;

      return (
        <CustomerServiceWorkingDay
          key={i} 
          day={slot.day} 
          isOpen={slot.isOpen} 
          index={i}
          isValid={isValid}
          onToggle={(index) => this.toggleDayAvailability(index)}
          onChangeTime={(edge: TimeEdge, val: string) => this.onChangeTime(i, edge, val)}
          startTime={slot.startTime}
          endTime={slot.endTime}
        />
      )
    })
  }

  handelCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => {
    return null;
  };

  handelLanguageChange = (langCode: string) => {
    if (langCode !== this.state.selectedLang) {
      if (this.isNew) {
        this.setState({
          selectedLang: langCode,
        });
      } else {
        this.getGate(langCode);
      }
    }
  };

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  getCancelButton = () => {
    return null;
  };

  onSubmit = async () => {
    try {
      const form = this.form.state;
      const gatesIntervals: GateOpenTimeInterval[] = this.getIntervals();
      if(!form.title) {
        SnackBarComponent.getInstance().openSnackbar("Title is required ", 3000, 'error');
        return;
      }
      if(!form.branchId) {
        SnackBarComponent.getInstance().openSnackbar("Branch is required ", 3000, 'error');
        return;
      }
      if(gatesIntervals.length < 1) {
        SnackBarComponent.getInstance().openSnackbar("Gate working hours is required ", 3000, 'error');
        return;
      } 
      if(form.title && form.branchId && !this.state.disabled) {
        this.setState({processing: true})
        let gate: any = {
          title: form.title,
          branchId: form.branchId,
          openTimeInterval: gatesIntervals,
          isActive: form.isActive
        }
        if(this.isNew) {
          const res = await this.props.gateStore.createGate(gate, this.isEgypt ? languageCodes.arabic : languageCodes.english , this.props.countryStore.managedCountries);
          if (this.isEgypt) {
            window.location.replace(`/gates/${res.gateId}/edit`);
          } else {
            this.props.history.go(this.lastHistory);
          }
        } else {
          gate.gateId = this.props.gateStore.selectedGate.gateId;
          await this.props.gateStore.updateGate(gate, this.state.selectedLang);
          window.location.replace(`/gates`);
        }
        SnackBarComponent.getInstance().openSnackbar("Saved Successfully", 3000, 'success'); 
      }
    } catch(error) {
      SnackBarComponent.getInstance().openSnackbar("Error occured while saving ", 3000, 'error');
    } finally {
      this.setState({processing: false})
    }
  }

  updateStateWithGateData = () => {
     const formFieldsWithData = [];
     for (const field of this.state.formFields) {
      if (field.name === 'title') {
        formFieldsWithData.push(
          {
            ...field, value: this.props.gateStore.selectedGate.title,
          },
        );
      } else if(field.name === 'branchId') {
        formFieldsWithData.push(
          {
            ...field, 
            selectList: this.props.branchStore.branchesList,
            value: this.props.gateStore.selectedGate.branchId,
          })
      } else if (field.name === 'isActive') {
        formFieldsWithData.push(
          {
            ...field, value: this.props.gateStore.selectedGate.isActive,
          }
        )
        } else {
        formFieldsWithData.push(field);
      }
    }
    this.setState({
      formFields: formFieldsWithData,
      loading: false,
    });
   }; 

  getIntervals(): GateOpenTimeInterval[] {
    const intervalsList: GateOpenTimeInterval[] = JSON.parse(JSON.stringify(this.state.intervals));
    const intervals =  intervalsList.map((interval: any) => {
      if(interval.startTime && interval.endTime) {
        delete interval.isOpen;

        return interval;
      }
    });

    return intervals.filter((interval: any) => !!interval);
  }

  render() {

    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.content}>
          {
            this.state.loading || this.props.gateStore.loading
              ? <Spinner />
              : (
                <div className={classes.body}>
              <GeneralFormComponent
                  ref ={(ref) => {this.form = ref}}
                  dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                  formTitle={this.gateFormTitle}
                  fields={this.state.formFields}
                  formSchema={this.gateSchema}
                  submitButton={this.submitButton}
                  cancelButton={this.cancelButton}
                  processing={this.state.processing}
                />
              <div className={classes.workDaysContainer}> 
                {this.renderWeekDays()}
              </div>
            <Button
              variant="contained"
              className={classes.submit}
              color="primary"
              onClick={() => this.onSubmit()}
              type="button"
              disabled={this.state.processing}
            >
              {this.state.processing? <Spinner /> : this.isNew && this.isEgypt ? 'To Next Language' : 'Submit'}
            </Button>

          </div>)
          }
        </div>
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore,
      branchStore,
    } = this.props;
    this.setState({loading: true});
    await countryStore.getUserManagedCountries();
    if (countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }
    if (!this.isNew) {
      const languageCode = this.isEgypt ? this.state.selectedLang : languageCodes.english;
      this.getGate(languageCode);
    }
    this.initState();
    await branchStore.getBranches(countryStore.managedCountries);
    this.updateStateWithBranchesData();
    this.setState({loading: false});
  }

  getGate = (langCode: string) => {
    this.setState({
      loading: true,
    });
    this.props.gateStore.getGatebyId(Number(this.gateId), langCode)
      .then(() => {
        this.updateStateWithGateData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
          intervals: this.props.gateStore.selectedGate.gateOpenTimeIntervals
        });
      }).catch(() => {
        this.setState({
          loading: false, 
        });
      });
  };
}

export default AddEditGate;
